import { render } from "./Equation.vue?vue&type=template&id=520ec9c8"
import script from "./Equation.vue?vue&type=script&lang=js"
export * from "./Equation.vue?vue&type=script&lang=js"

import "./Equation.vue?vue&type=style&index=0&id=520ec9c8&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__